import { get, map, size, filter } from "lodash";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import { I18n } from "@aws-amplify/core";
import React from "react";

import { getAttributeName } from "../../utils/attributes";
import { getAttributeValue } from "../../utils/profile";
import { fetchGet, fetchPost } from "../../api/fetch";
import SmartSearchNew from "../Common/SmartSearchNew";
import InfoSection from "../Common/InfoSection";
import FormSection from "../Common/FormSection";
import Picture from "../Common/Picture";

export const CreateUserFromProfile = (props) => {
  const {
    language,
    selectedProfile,
    lov,
    setSelectedProfile,
    values,
    handleChange,
    errors,
    valid,
  } = props;

  const getProfileSuggestions = async (input) => {
    try {
      let suggestions = await fetchPost("profiles/search", {
        search_text: input,
        types: [1],
      });

      suggestions.forEach((suggestion) => {
        if (suggestion.firstname && suggestion.lastname) {
          suggestion.name = suggestion.firstname + " " + suggestion.lastname;
        }
      });

      return suggestions;
    } catch (error) {
      console.log(error);
    }
  };

  const handleProfileSelect = async (profile) => {
    if (get(profile, ["id"])) {
      try {
        const completeProfile = await fetchGet(`profiles/${profile.id}`);

        setSelectedProfile(completeProfile);
      } catch (error) {
        console.error(error);
      }
    } else {
      setSelectedProfile();
    }
  };

  return (
    <>
      <Box style={{ marginBottom: "20px" }}>
        <SmartSearchNew
          getSuggestions={getProfileSuggestions}
          filter={["name"]}
          onSelect={handleProfileSelect}
        />
      </Box>
      <InfoSection
        title2={getAttributeName(31)}
        values={[getAttributeValue(selectedProfile, 31)]}
      />
      <InfoSection
        title2={getAttributeName(32)}
        values={[getAttributeValue(selectedProfile, 32)]}
      />
      <InfoSection
        title2={getAttributeName(33)}
        values={[getAttributeValue(selectedProfile, 33)]}
      />
      <InfoSection
        title={"tag"}
        values={[get(selectedProfile, ["tag", `name_${language}`])]}
        color={get(selectedProfile, ["tag", "color_rgb"])}
      />
      <InfoSection
        title2={getAttributeName(35)}
        values={[getAttributeValue(selectedProfile, 35, lov, language)]}
      />
      <Grid item style={{ padding: "8px", maxWidth: "100%" }}>
        <Box className="text-87 bold-500">{I18n.get("profiles_photos")}</Box>
        <Grid container>
          {size(
            filter(
              get(selectedProfile, ["images"]),
              (img) => img.active && img.enrollment_status
            )
          ) === 0
            ? "-"
            : map(
              filter(
                get(selectedProfile, ["images"]),
                (img) => img.active && img.enrollment_status
              ),
              (img) => (
                <Grid item key={img.url} style={{ marginRight: "10px" }}>
                  <Picture
                    url={img.url}
                    maxHeight={70}
                    style={{ maxHeight: "70px", maxWidth: "70px" }}
                  />
                </Grid>
              )
            )}
        </Grid>
      </Grid>
      <FormSection
        formValue={[get(values, ["username"]) || ""]}
        setFormValue={handleChange}
        title="username"
        id="username"
        options={{
          required: true,
          errorMsg: errors["username"],
          redBorder: !get(valid, ["username"]),
        }}
      />
      <FormSection
        formValue={get(values, ["roles"]) || []}
        setFormValue={handleChange}
        title="roles"
        id="roles"
        type="select"
        options={{
          multipleSelect: true,
          required: true,
          redBorder: !get(valid, ["roles"]),
          errorMsg: errors["roles"],
          options: map(get(lov, ["roles"]), (t) => ({
            id: t.id,
            name: t[`name_${language}`],
          })),
        }}
      />
    </>
  );
};
